"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Date = exports.getFormattedDate = void 0;

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/sv");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var daysFromNow = function daysFromNow(date) {
  var m = (0, _moment["default"])(date); // or whatever start date you have

  var today = _moment["default"].now();

  return Math.round(_moment["default"].duration(m - today).asDays());
};

var getFormattedDate = function getFormattedDate(variant, date) {
  if (!date) {
    return '-';
  }

  switch (variant) {
    case 'default':
      return (0, _moment["default"])(date).locale('en').format('Do MMMM YYYY');

    case 'ago':
      return (0, _moment["default"])(date).locale('en').fromNow();

    case 'time':
      return (0, _moment["default"])(date).locale('en').format('HH:mm');

    case 'days-from-now':
      return daysFromNow(date);

    case 'full':
      return (0, _moment["default"])(date).locale('en').format('Do MMMM YYYY HH:mm');

    default:
      break;
  }
};

exports.getFormattedDate = getFormattedDate;

var Date = function Date(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      children = _ref.children;
  return getFormattedDate(variant, children);
};

exports.Date = Date;